// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Warnings_wrapper__vOCiS","mainContainer":"Warnings_mainContainer__C7xRX","split":"Warnings_split__KGCEe","splittedList":"Warnings_splittedList__4wdRv"};